<template>
  <div class="c-machinelist">
    <v-dialog
      v-model="dialog"
      max-width="600px"
      v-if="hasRole('admin')"
      eager
    >
      <machine-edit
        ref="editor"
        @dismissed="dialog = false"
        @saved="dialog = false"
      ></machine-edit>
    </v-dialog>

    <v-row>
      <v-col cols="auto">
        <div class="page-title">Liste des machines</div>
          <v-alert :value="!!error" type="error">
            {{ error }}
          </v-alert>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="auto">
        <v-row>
          <v-btn
            color="primary"
            class="mb-2 mx-1"
            @click.stop="addItem"
            v-if="hasRole('admin')"
          >
            Ajouter
          </v-btn>
          <v-btn
            color="primary"
            class="mb-2 mx-1"
            @click="exportMachines"
            v-if="hasRole('admin')"
          >
            Exporter toutes
            <v-icon right>save_alt</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="auto">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          item-key="machine_id"
          hide-default-footer
          disable-pagination
          class="elevation-1 transparent"
        >
          <template v-slot:item="{ item }">
            <tr class="c-machinelist__tablerow" @click="goToItem(item)">
              <td v-if="hasColumn('serial')">{{ item.serial_number }}</td>
              <td v-if="hasColumn('client')">{{ clientData(item).name }}</td>
              <td v-if="hasColumn('country')">{{ clientData(item).address.country }}</td>
              <td v-if="hasColumn('city')">{{ clientData(item).address.city }}</td>
              <td v-if="hasColumn('revenue')">{{ item.revenue || 'ND' }}</td>

              <td class="justify-center layout px-0">
                <v-tooltip bottom v-if="hasRole('admin')">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" v-on="on" @click.stop="editItem(item)">
                      <v-icon color="teal">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editer</span>
                </v-tooltip>
                <v-tooltip bottom v-if="hasRole('admin')">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" v-on="on" @click.stop="deleteItem(item)">
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ExportAPI from '@/api/export';

import MachineEdit from '@/components/MachineEdit';

import CSVExport from '@/mixins/CSVExport';
import ErrorManagement from '@/mixins/ErrorManagement';
import PeriodListener from '@/mixins/PeriodListener';
import RoleFiltering from '@/mixins/RoleFiltering';

import { MACHINE_DELETE, MACHINE_LIST } from '@/store/actions/machine';


export default {
  name: 'MachineList',

  mixins: [
    CSVExport,
    ErrorManagement,
    PeriodListener,
    RoleFiltering
  ],

  components: {
    MachineEdit
  },

  props: {
    clientId: {
      type: Number
    }
  },

  data: () => ({
    loading: false,

    headersAdmin: [
      { text: 'Nom de la machine', value: 'serial' },
      { text: 'Nom du client', value: 'client' },
      { text: 'Pays', value: 'country' },
      { text: 'Ville', value: 'city' },
      { text: 'CA (€)', value: 'revenue' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],

    headersClient: [
      { text: 'Nom de la machine', value: 'serial' },
      { text: 'CA (€)', value: 'revenue' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],

    dialog: false,
    editedItem: {}
  }),

  computed: {
    ...mapState({
      items: state => state.machine.machines,
      defaultItem: state => state.machine.defaultItem
    }),
    headers () {
      switch (this.role) {
        case 'admin':
          return this.headersAdmin;

        case 'client':
          return this.headersClient;

        default:
          return [];
      }
    }
  },

  mounted () {
    this.fetchData();
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },

  beforeRouteUpdate (to, from, next) {
    this.fetchData();
    next();
  },

  methods: {
    hasColumn (name) {
      return !!this.headers.find(elt => elt.value === name);
    },

    fetchData () {
      this.loading = true;
      this.$store.dispatch(MACHINE_LIST, { client_id: this.clientId })
        .catch((err) => {
          this.setError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clientData (item) {
      return this.$store.getters.getClientById(item.client_id);
    },

    addItem () {
      this.$refs.editor.edit(null);
      this.dialog = true;
    },
    editItem (item) {
      this.$refs.editor.edit(item);
      this.dialog = true;
    },
    goToItem (item) {
      this.$router.push({ name: 'machineDetail', params: { machineId: item.machine_id } });
    },
    deleteItem (item) {
      if (!confirm('Etes-vous sûr de vouloir supprimer cette machine ?')) {
        return;
      }

      this.$store.dispatch(MACHINE_DELETE, item.machine_id)
        .catch((err) => {
          this.setError(err);
        });
    },
    exportMachines () {
      this.saveCSV(ExportAPI.getMachines(), 'export_machines');
    }
  }
};
</script>

<style lang="scss" scoped>
.c-machinelist {
  &__tablerow {
    cursor: pointer;
  }
}
</style>
